'use strict'

module.exports = function() {
	$('#header-promo-bar').carousel({
		interval: 4000,
		keyboard: true,
		wrap: true,
		ride: "carousel"
	}).find('.carousel-item').first().addClass('active');
};
